export default {
  StudentClassroom: {
    HaventJoinedClassYet:
      'Bạn chưa tham gia lớp học nào. Hãy liên hệ với giáo viên phụ trách để nhận mã lớp và bắt đầu học tập.',
    JoinClass: 'Tham gia lớp học',
    AwaitingApproval: 'Đang chờ phê duyệt',
    PleaseContactYourTeacher:
      'Hãy liên hệ giáo viên của bạn để lấy mã lớp và bắt đầu sử dụng nhé!',
    CheckClassInformation:
      'Hãy kiểm tra thông tin cơ bản về lớp học để chắc chắn rằng bạn tìm thấy đúng lớp của mình nhé!',
    ClassInformationFull: 'Thông tin lớp học',
    ClassInformation: 'Thông tin lớp',
    NotTheClassWantToJoin: 'Không phải lớp bạn muốn tham gia?',
    JoinClassSuccess: 'Tham gia lớp học thành công',
    WaitForApproval: 'Chờ phê duyệt từ giáo viên',
    DescriptionApproval:
      'Lớp học bạn đăng ký cần sự phê duyệt của giáo viên phụ trách để tham gia.',
    GetTheClassCodeBack: 'Nhập lại mã lớp',
    JoinOtherClass: 'Tham gia thêm lớp học khác',
    LeaveClass: 'Rời lớp học',
    ButtonLeaveClass: 'Rời lớp',
    ClassJoinng: 'Lớp học đang tham gia',
    ClassName: 'Tên lớp',
    TeacherName: 'Giáo viên',
    OrganizationName: 'Trường',
    GradeName: 'Khối',
    Subject: 'Môn học',
    Description: 'Mô tả',
    AreYouSureQuit:
      'Bạn có chắc muốn rời lớp <strong>{entityName}</strong> không?',
    DeleteClassSuccess: 'Xóa lớp học thành công',
    DeleteClassFail: 'Xóa lớp học thất bại',
    ClassWaitAppro: 'Lớp học đang chờ phê duyệt',
    CancelWaitAppr: 'Hủy yêu cầu',
    CancelWaitApproveSuccess: 'Huỷ yêu cầu thành công!',
    DescriptionUserOption: 'Tải lên lớp học khi load bài tập của học sinh',
    SearchStudent: 'Nhập tên bạn học để tìm kiếm',
    ListFriendly: 'Danh sách bạn học trong lớp ({total})',
    DateBirth: 'Ngày sinh',
    NoFriendlyInClass: 'Chưa có bạn học',
    NotFoundFriendly: 'Không tìm thấy bạn học',
    StudentClassroomUp:
      'Chúc mừng bạn đã được lên lớp <br/> <span>{className}!</span>',
    StudentClassroomStay:
      'Năm học mới bạn cố gắng <br/> phấn đấu hơn với lớp <span>{className}</span> nhé!'
  }
}
